import 'selectize/dist/js/selectize';
/* This is selectize life now, after buildjob update, it will fail with
* uncaught TypeError: t(...).selectize is not a function
* Unless it is loaded like this.
* */
$( document ).ready( function( $ ) { // eslint-disable-line no-undef
	$( '#taxonomy-select' ).change( function() {
		const targetPosition = $( $( this ).val() ).offset().top;
		$( 'html, body' ).animate( { scrollTop: targetPosition - 70 }, 'slow' );
	} );

	$( '#taxonomy-select' ).selectize();
	$( '#site-footer select' ).selectize();
} );

import 'bootstrap';
import Flickity from 'flickity-imagesloaded';
import objectFitImages from 'object-fit-images';
import svg4everybody from 'svg4everybody';

jQuery( document ).ready( function( $ ) {
	require( './click-to-scroll' );
	require( './ac-mobile-menu' );
	require( './search-filter' );
	require( './skip-link-focus-fix' );

	objectFitImages();
	svg4everybody();

	$( '.nav-search' ).on( 'click', function() {
		$( '#search-container' ).slideToggle( 150, function() {
			$( this ).find( '.form-control' ).focus();
		} );
	} );

	const reviews = document.querySelector( '.reviews-slider' );
	if ( $( ( '.reviews-slider' ) ).length ) {
		/* eslint-disable no-unused-vars */
		const flkty = new Flickity( reviews, {
			cellAlign: 'left',
			contain: true,
			pageDots: true,
			imagesLoaded: true,
		} );
		/* eslint-enable no-unused-vars */
	}
	const educations = document.querySelector( '.educations-slider.educations' );
	if ( $( ( '.educations-slider.educations' ) ).length ) {
		/* eslint-disable no-unused-vars */
		const flktyEducations = new Flickity( educations, {
			cellAlign: 'left',
			contain: true,
			pageDots: true,
			imagesLoaded: true,
		} );
		/* eslint-enable no-unused-vars */
	}
	const courses = document.querySelector( '.educations-slider.courses' );
	if ( $( ( '.educations-slider.courses' ) ).length ) {
		/* eslint-disable no-unused-vars */
		const flktyCourses = new Flickity( courses, {
			cellAlign: 'left',
			contain: true,
			pageDots: true,
			imagesLoaded: true,
		} );
		/* eslint-enable no-unused-vars */
	}
	const companyCourses = document.querySelector( '.educations-slider.company_courses' );
	if ( $( ( '.educations-slider.company_courses' ) ).length ) {
		/* eslint-disable no-unused-vars */
		const flktyCompanyCourses = new Flickity( companyCourses, {
			cellAlign: 'left',
			contain: true,
			pageDots: true,
			imagesLoaded: true,
		} );
		/* eslint-enable no-unused-vars */
	}
	const slideNav = document.querySelector( '.slide-nav ul' );
	if ( $( ( '.slide-nav ul' ) ).length ) {
		/* eslint-disable no-unused-vars */
		const flkty3 = new Flickity( slideNav, {
			cellAlign: 'left',
			contain: false,
			pageDots: false,
			imagesLoaded: true,
			prevNextButtons: false,
		} );
		/* eslint-enable no-unused-vars */
	}
	const slideSingleNav = document.querySelector( '.single-nav' );
	if ( $( ( '.single-nav' ) ).length ) {
		/* eslint-disable no-unused-vars */
		const flkty4 = new Flickity( slideSingleNav, {
			cellAlign: 'left',
			contain: false,
			pageDots: false,
			imagesLoaded: true,
			prevNextButtons: false,
		} );
		/* eslint-enable no-unused-vars */
	}
	const slideFaqNav = document.querySelector( '.faq-nav' );
	if ( $( ( '.faq-nav' ) ).length ) {
		/* eslint-disable no-unused-vars */
		const flkty5 = new Flickity( slideFaqNav, {
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			imagesLoaded: true,
			prevNextButtons: true,
		} );
		/* eslint-enable no-unused-vars */
	}
	$( '.nav-tabs a' ).click( function( e ) {
		e.preventDefault();
		$( this ).tab( 'show' );
	} );

	$( '.banner-content-icon' ).on( 'click', function() {
		$( '.information-banner' ).hide();
	} );

	$( '.faqs' ).on( 'click', '.faq-trigger', function( e ) {
		e.preventDefault();

		const $this = $( this );
		$this.toggleClass( 'open' );
		$this.next().slideToggle( 300 );
	} );

	$( '.apply-link' ).on( 'click', function() {
		const targetPosition = $( '.apply-form-container' ).offset().top;
		$( 'html, body' ).animate( { scrollTop: targetPosition - 70 }, 'slow' );
	} );

	$( '#gotopage' ).on( 'click', function() {
		const parentPageUrl = 'vara-utbildningar-kurser';
		const posttype = $( 'select[name=post-type]' ).val();
		const category = $( 'select[name=category]' ).val();
		if ( '' !== category ) {
			window.location.href = '/' + parentPageUrl + '/' + posttype + '#' + category;
		} else {
			window.location.href = '/' + parentPageUrl + '/' + posttype;
		}
	} );

	if ( 0 !== $( '#course-form' ).length ) {
		const defaultOption = $( '#course-form .select-topic' ).html();
		updateOptions( $( '#course-form .select-courses-educations' ), defaultOption );

		$( '#course-form .select-courses-educations' ).change( 'select', function() {
			updateOptions( this, defaultOption );
		} );
	}

	function updateOptions( element, defaultOption ) {
		const categories = $( element ).find( ':selected' ).data( 'categories' );
		let html = defaultOption;
		for ( const category of categories ) {
			html += '<option value="' + category.slug + '">' + category.name + '</option>';
		}

		$( '#course-form .select-topic' ).html( html );
	}
} );
